import $ from "../libs/jquery-3.3.1.min.js"
import {BaseGameLimno} from "/js/app/base/BaseGameLimno";
import {AudioPlaylist} from '/js/app/base/AudioPlaylist.js'
import {Avatar} from "/js/app/components/Avatar.js";
import {gsap} from "/js/libs/gsap/all.js"
import {Howl} from "howler";

// Constructor
export class Register extends BaseGameLimno {

  constructor(topicId) {

    // Super constructor
    super("data/register.json", "LIMNO/STATION" + topicId);
    this.screensaverDelay = 45;

    this.playlist = new AudioPlaylist();

    this.currentTimeline = null;
  }

  // To be overridden in child games
  initGame() {

    super.initGame();

    this.avatar.setFloating(true);

    // if (inElectron()) {
    //   this.playAudioAmbiance();
    // } else {
    //   $(window).one('click', this.playAudioAmbiance());
    // }

    // Dev
    // setTimeout(() => {
    //   console.log("Dev mode on")
    //   const visitorData = JSON.parse(this.simulator.buildMessageFromInputs());
    //   if (visitorData.length > 0) {
    //     this.currentVisitorData = visitorData[0];
    //     this.initVisitor().then(() => {
    //       this.goToScreen(5);
    //       // this.selectZone("0");
    //     });
    //   }
    // }, 450)

    // Go to first screen
    // if (inElectron()) {
    // this.initScreenSaver();
    // this.goToScreen(1);
    // } else {
    // 	$("#first-click-interact").one(this.touchEvent, $.proxy(this.initScreenSaver, this));
    // 	this.goToScreen("first-click-interact");
    // }

    // this.i18n.set("fr");

  };

  // To be overridden in child games
  initScreen(screenId) {

    // Super constructor
    if (super.initScreen(screenId) == false) {
      return false;
    }

    switch (screenId) {
      case 1:
        break;
      case 2:
        this.animateScreen2();
        break;
      case 3:
        this.animateScreen3();
        break;
      case 6:
        this.animateScreen6();
        break;
    }
  }

  // To be overridden in child games
  onMessage(e) {
    const type = e.type;
    const visitorData = e.visitorData;
    console.log("message received : ", type, visitorData);

    this.resetTimer();

    if (this.stillThereTimeout != false) {
      this.closeStillThereModal();
      // this.initScreenAudio(this.currentScreen);
      return;
    }

    // In all time, reset on tag remove
    if (type === "tagRemove") {
      this.reset(1);
    }

    // On screen 1, load data on tag drop
    if (this.targetScreen === 1 && type === "tagDrop") {
      // Todo Define langugage from User profile
      this.initVisitor().then(() => {
        // Clear current tag data
        this.resetTag();
        // Go to screen 2
        this.goToScreen(2, null, true);
      });
    }
  }

  selectLanguage(e) {
    const language = $(e.currentTarget).data("lang");
    this.i18n.setWithFlip(language);

    this.tagUpdateRecord("LANGUAGE", (language === "fr" ? "FRA" : "ENG"));
    this.tagUpdateRecord("ST_INTRODUCTION", "2");
    this.tagSaveCurrentData();

    if (this.timeout !== false) {
      clearTimeout(this.timeout);
      this.timeout = false;
    }

    this.timeout = setTimeout(() => this.goToScreen(3), 200)
  }

  selectAge(age) {
    this.tagUpdateRecord("AGE", age.toString().toUpperCase());
    this.tagUpdateRecord("ST_INTRODUCTION", "3");
    this.tagSaveCurrentData();

    if (this.timeout !== false) {
      clearTimeout(this.timeout);
      this.timeout = false;
    }

    this.timeout = setTimeout(() => this.goToScreen(4), 200)
  }

  selectTheme(theme) {
    this.tagUpdateRecord("WALLPAPER", theme.toString().toUpperCase());
    this.tagUpdateRecord("ST_INTRODUCTION", "4");

    this.clearTheme();
    this.applyTheme(theme);

    $(`#screen-${this.currentScreen} .options .trigger`).removeClass("active");
    $(`#screen-${this.currentScreen} .options .trigger[data-action-arg='${theme}']`).addClass("active")
    $(`#screen-${this.currentScreen} .actions .button`).removeClass("disabled");
  }

  selectEmotion(emotion) {
    this.tagUpdateRecord("EMOTION", emotion.toString().toUpperCase());
    this.tagUpdateRecord("ST_INTRODUCTION", "TRUE");

    this.avatar.setAvatar(emotion);

    $(`#screen-${this.currentScreen} .options .trigger`).removeClass("active");
    $(`#screen-${this.currentScreen} .options .trigger[data-action-arg='${emotion}']`).addClass("active")
    $(`#screen-${this.currentScreen} .actions .button`).removeClass("disabled");
  }

  saveTagAndGoToScreen(screenId) {
    this.tagSaveCurrentData();
    this.timeout = setTimeout(() => this.goToScreen(screenId), 200)
  }

  resetTag() {
    console.log("resetTag")
    this.tagUpdateRecord("LANGUAGE", "NULL")
    this.tagUpdateRecord("AGE", "NULL")
    this.tagUpdateRecord("WALLPAPER", "NULL")
    this.tagUpdateRecord("EMOTION", "NULL")
    this.tagUpdateRecord("ST_INTRODUCTION", "FALSE")
    this.tagUpdateRecord("ST_DISCOVERY_01", "FALSE")
    this.tagUpdateRecord("ST_DISCOVERY_02", "FALSE")
    this.tagUpdateRecord("ST_DISCOVERY_03", "FALSE")
    this.tagUpdateRecord("ST_DISCOVERY_04", "FALSE")
    this.tagUpdateRecord("ST_LOGBOOK_01", "FALSE")
    this.tagUpdateRecord("ST_LOGBOOK_02", "FALSE")
    this.tagUpdateRecord("ST_LOGBOOK_03", "FALSE")
    this.tagUpdateRecord("ST_LOGBOOK_04", "FALSE")
    this.tagUpdateRecord("ST_OUTRO", "FALSE")
    this.tagSaveCurrentData();
  }

  animateScreen2() {
    this.currentTimeline = gsap.timeline();

    this.currentTimeline.fromTo($(`#avatar`), {
      y: 100,
      x: 0,
    }, {
      y: 0,
      autoAlpha: 1,
      duration: 0.5,
      delay: 0.5
    });
  }

  animateScreen3() {
    this.currentTimeline = gsap.timeline();

    this.currentTimeline.to($(`#avatar`), {
      x: -500,
      duration: 1.5,
      ease: "power1.inOut",
    });
    this.currentTimeline.fromTo($(`#age-selectors`, `#screen-3`), {
      autoAlpha: 0,
    }, {
      autoAlpha: 1,
      duration: 0.5,
    });
  }

  animateScreen6() {
    this.currentTimeline = gsap.timeline();

    this.currentTimeline.to($(`#avatar`), {
      x: -655,
      y: 270,
      duration: 1.5,
      ease: "power1.inOut",
    });

    this.currentTimeline.fromTo($(`#finale, .rfid-cta`, `#screen-6`), {
      autoAlpha: 0,
    }, {
      autoAlpha: 1,
      duration: 0.5,
      delay: 1.5,
    });

    this.currentTimeline.add(() => this.sendLedMessage())
  }

  goToScreenSaver() {

    // Super constructor
    if (super.goToScreenSaver() == false) {
      return false;
    }
  }

  reset(screenId) {

    if (this.currentTimeline) {
      this.currentTimeline.kill();
      this.currentTimeline = null;
    }

    let resetCallback = () => {
      // TODO Add things to append after reset here, if required
      gsap.set($(`#avatar`), {
        y: 0,
        x: 0,
        autoAlpha: 0,
      });
    }

    // TODO Reset other things here
    $(".actions .button.trigger").addClass("disabled");
    $(".options .trigger").removeClass("active");
    this.clearTheme();
    this.avatar.setAvatar(null);
    gsap.to($(`#avatar`), {
      autoAlpha: 0,
      duration: 0.5,
    });

    if (typeof screenId == "undefined") {
      resetCallback();
    }

    // Super
    if (super.reset(screenId, resetCallback) == false) {
      return false;
    }

  }
}
